import { render, staticRenderFns } from "./farming.vue?vue&type=template&id=4b631017"
import script from "./farming.vue?vue&type=script&lang=js"
export * from "./farming.vue?vue&type=script&lang=js"
import style0 from "./farming.vue?vue&type=style&index=0&id=4b631017&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports